import { orderHistoryPaginationStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryPagination";
import { getMgbwPaginationOverrides } from "@tSurya/Common/Utilities/mgbwPaginationOverrides";

orderHistoryPaginationStyles.pagination = getMgbwPaginationOverrides();
